<template>
  <div :style="style">
    <img :src="logoSrc" :width="width" :height="height" />
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    width: {
      type: Number | String,
      default: 300
    },
    height: {
      type: Number | String,
    }
  },
  computed: {
    style() {
      return {
        height: "inherit"
      };
    },
    logoSrc() {
      //return require(`@/assets/images/header_icon_left.png`);
      return "";
    }
  },
  watch: {},
  methods: {}
};
</script>
<style module lang="scss">
</style>
